import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { VisualVO } from "./VisualVO";

export class TablesVO extends VisualVO {
    // DONT USE
    constructor() {
        super();
    }
}
classImplementsInterfaces(TablesVO, "IInventoryVO");
